import { camelCase } from 'lodash'

export default {
  keysToCamelCase(obj) {
    if (Array.isArray(obj)) {
      return obj.map((x) => this.keysToCamelCase(x))
    } else if (obj != null && obj.constructor === Object) {
      return Object.keys(obj).reduce(
        (result, key) => ({
          ...result,
          [camelCase(key)]: this.keysToCamelCase(obj[key]),
        }),
        {}
      )
    }
    return obj
  },
}
